import React, { useState, useEffect, useRef, useContext } from "react";
import ReactDOM from 'react-dom/client';
import PutniNalogZaStampu from "./putniNalogStrana1";
import PutniNalogZaStampu2 from "./putniNalogStrana2";

const pdfPage = "/putniNalogStrana2.pdf";

const printContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Putni nalog - Štampa</title>
          <style>
            * {
              box-sizing: border-box;
              margin: 0;
              padding: 0;
            }
            body, html {
              width: 100%;
              height: 100%;
              margin: 0;
              padding: 0;
              font-family: Arial, sans-serif;
              font-size: 9pt;
            }
            #print-content {
              width: 90%;
              margin: 5%;
            }
            @page {
              size: landscape;
              margin: 0;
            }
            @media print {
              body, html {
                width: 100% !important;
                height: 100% !important;
                margin: 0 !important;
                padding: 0 !important;
                font-size: 8pt !important;
              }
              #print-content {
                width: 90% !important;
                margin: 5% !important;
                transform: scale(1);
                transform-origin: top left;
              }
              .putni-nalog-container {
                width: 100% !important;
                max-width: 100% !important;
                margin: 0 !important;
                padding: 0 !important;
              }
              table {
                width: 100% !important;
                max-width: 100% !important;
                
              }
              td {
                padding: 1px !important;
                height: 10px !important;
                font-size: 8pt !important;
              }
              .empty-cell {
                height: 6px !important;
              }
              .col0, .col1, .col2, .col3, .col4, .col5, .col6, 
              .col7, .col8, .col9, .col10, .col11, .col12, .col13 {
                width: auto !important;
              }
                .column0 .column1 .column2 .column3 .column4 .column5 .column6 
                .column7 .column8 .column9 .column10 .column11 .column12 .column13  {
                border: 1px solid black;
              }
            }
          </style>
        </head>
        <body>
          <div id="print-content"></div>
        </body>
      </html>
    `;
export default function handlePrint(podaci) {
  
    const printWindow = window.open('', '_blank', 'width=1000,height=700');

    const printStyles = `
   @page { 
        margin-left: 0.7in; 
        margin-right: 0.7in; 
        margin-top: 0.75in; 
        margin-bottom: 0.75in; 
    }
    body { 
        margin-left: 0.7in; 
        margin-right: 0.7in; 
        margin-top: 0.75in; 
        margin-bottom: 0.75in; 
        font-family: Arial, sans-serif;
        font-size: 11pt;
    }
    .putni-nalog-container {
        width: 100%;
    }
    .putni-nalog-container tr {
        border-right: none;
    } 
    table {
        width: 100%;
        border-collapse: collapse;
    }
    td {
        padding: 2px;
        vertical-align: top;
        background-color: white;
        border: 1px solid black;
    }
    .text-center {
        text-align: center;
    }
    .bold {
        font-weight: bold;
    }
    .empty-cell {
        height: 20px;
    }
    .column5 {
        width: 4%;
        border-top: none;
        border-bottom: none;
        border-right: none;
    }
    .column6, .column7, .column8, .column9, 
    .column10, .column11, .column12, .column13 {
        border: none;
    }
    .borderLeftAndRightNone {
        border-left: none !important;
        border-right: none !important;
    }
    
    /* ISPRAVLJENI stilovi za rotiranu tabelu */
    .rotated-table-container {
        page-break-before: always;
        width: 100%;
        margin: 0;
        padding: 0;
    }
    
    .rotated-wrapper {
        width: 100%;
        height: 100%;
        display: block;
        position: relative;
    }
    
    .rotated-table {
        width: 100%;
        transform: rotate(-90deg);
        transform-origin: center center;
        border-collapse: collapse;
    }
    
    .rotated-table td {
        border: 1px solid black;
        padding: 4px 8px;
        text-align: center;
    }
    
    .borderBottomNone {
        border-bottom: none !important;
    }
    
    .displayTextFlex {
        text-align:center;
    }
    
    .verticalAlign {
        vertical-align: middle;
    }
    
    .borderTopNone {
        border-top: none !important;
    }
    
    .borderLeftNone {
        border-left: none !important;
    }
    
    .borderRightNone {
        border-right: none !important;
    }
    
    .borderSecondTable {
        border: 1px solid black;
        padding: 4px 8px;
    }
    
    /* Poboljšani stilovi za štampu */
    @media print {
        .rotated-table-container {
            page-break-before: always;
            width: 100vw;
            height: 100vh;
            position: relative;
            left: 0;
            top: 0;
            margin: 0;
            padding: 0;
        }
        
        .rotated-wrapper {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(90deg);
            width: 100vh;
            height: 100vw;
        }
        
        .rotated-table {
            transform: none;
            width: 100%;
            height: 100%;
        }
        
        /* Osigurava da se sadržaj ne seče na ivicama prilikom štampe */
        body, html {
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
        }
    }
`;

    printWindow.document.open();
    printWindow.document.write(printContent);
    const styleEl = printWindow.document.createElement("style");
    styleEl.textContent = `
  /* A4 landscape bez margina printera */
  @page { size: A4 landscape; margin: 0; }
  html, body { margin: 0; padding: 0; }

  /* Svaka strana je tačno A4 landscape "page box" */
  .print-page {
    position: relative;
    display: block;
    width: 297mm;
    height: 210mm;
    overflow: hidden;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  /* 1. strana – tvoje postojeće margine rešavaj padding-om kontejnera */
  .print-page.first { padding: 0.75in 0.7in; }

  /* 2. strana – počinje na novoj strani */
  .print-page.second {
    break-before: page;
    page-break-before: always;
    padding: 0;
  }

  /* === 5% "padding" oko DRUGE strane (tačno u mm) ===
     5% od 297mm = 14.85mm levo/desno, 5% od 210mm = 10.5mm gore/dole */
  .pg2-viewport {
    position: absolute;
    left: 14.85mm;
    top: 10.5mm;
    width: calc(297mm - 29.7mm);   /* 297 - 2*14.85 = 267.3mm */
    height: calc(210mm - 21mm);    /* 210 - 2*10.5 = 189mm */
    overflow: hidden;
  }

  /* Rotirani "kanvas" bez skaliranja: 0.9 * portret A4 => 189 x 267.3mm
     Rotacijom -90° postaje 267.3 x 189 i savršeno staje u pg2-viewport */
  .rot-fit {
    position: absolute;
    top: 50%; left: 50%;
    width: 189mm;         /* = 0.9 * 210mm */
    height: 267.3mm;      /* = 0.9 * 297mm */
    transform: translate(-50%, -50%) rotate(-90deg);
  }

  /* Tabela zauzima ceo rotirani kanvas */
  .rotated-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  .rotated-table col { width: calc(100% / 24); }

  .rotated-table td {
    border: 0.25mm solid #000;
    padding: 2px;
    box-sizing: border-box;
    overflow: hidden;
  }

  /* Fiksni redovi od 25px: prva 3 i poslednja 4 */
  .row25 td {
    height: 25px !important;
    max-height: 25px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    white-space: nowrap;
  }
   :root{
  --pg2-fixed-row-h: 25px;   /* fiksna visina za header/footer redove */
  --pg2-header-rows: 3;      /* prva 3 reda */
  --pg2-footer-rows: 4;      /* poslednja 4 reda */
  --body-rows: 18;           /* <- BROJ srednjih redova koji treba da se rastegnu (promeni po potrebi!) */
}

/* Tabela na drugoj strani N E K A bude tačno H=100% prostora rot-fit-a */
.rotated-table{
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

/* Fiksni redovi (header/footer) – ne smeju da rastu */
.row25 td{
  height: var(--pg2-fixed-row-h) !important;
  max-height: var(--pg2-fixed-row-h) !important;
  line-height: var(--pg2-fixed-row-h) !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  white-space: nowrap;
  overflow: hidden;
}

/* R A S T E G L J I V I redovi u sredini – ravnomerno podele preostalu visinu */
.grow-row td{
  height: calc(
    (100% - (var(--pg2-header-rows) + var(--pg2-footer-rows)) * var(--pg2-fixed-row-h))
    / var(--body-rows)
  ) !important;
  /* bez line-height-a, da sadržaj normalno stoji */
}
`;
    printWindow.document.head.appendChild(styleEl);
    printWindow.document.close();

    const printDocument = printWindow.document;
    const printContainer = printDocument.getElementById('print-content');

    const { createRoot } = ReactDOM;
    const root = createRoot(printContainer);

    root.render(
      <>
        {/* Prva strana - simulacija landscape */}
        <div className="landscape-wrapper">
          <PutniNalogZaStampu podaci={podaci} />
        </div>
        <div className="print-page second">
            <div className="pg2-viewport">
                <div className="rot-fit">
                <PutniNalogZaStampu2/>
                </div>
            </div>
        </div>
        {/* <div className="second-page">
          <PutniNalogZaStampu2 page={1} scale={2} pdfUrl={pdfPage} />
        </div> */}
        {/* Druga strana - normalno portrait */}
        
      </>
    );

    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 500);

};